import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

export default async campaignId => {
  const query = `query 
    ($campaignId:ID!) {
      campaign(id:$campaignId){
        id
        name
        type
        cityPlans {
          nodes {
            city {
              id
              name
            }
          }
        }
        country {
            cities {
                edges {
                    node {
                        id
                        name
                    }
                }
            }
        }
    }
}`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/CityPlanCreate/gql.js